/**
 * Cadeau offert : ouverture du drawer de sélection et ajout du cadeau à 0.
 *
 * Markup : snippets/cart__gift-cta.liquid (CTA dans le panier) et
 * snippets/cart__gift-picker.liquid (drawer latéral).
 *
 * Le CTA et le drawer vivent dans deux conteneurs `.cart-reload[id]` distincts,
 * tous deux remplacés par innerHTML à chaque rafraichissement du panier. Les
 * clics passent donc par une délégation au niveau du document : rien à
 * re-brancher après un refresh. Seule la suppression automatique du cadeau a
 * besoin d'un hook au rendu, d'où le custom element <apt-cart-gift-picker>.
 *
 * L'état ouvert/fermé est porté par la classe `gift-open` sur <apt-cart-drawer>,
 * qui n'est jamais remplacé et survit donc aux rafraichissements.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'gift-open';

  // Garde-fou : si la suppression automatique échoue, le panier est rafraichi et
  // le composant re-monté avec le même flag. On borne les tentatives pour éviter
  // une boucle de requêtes.
  var MAX_AUTO_REMOVE_ATTEMPTS = 3;
  var autoRemoveAttempts = 0;

  var busy = false;

  function cartRoute(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed with status ' + response.status);
      }
      return response.json();
    });
  }

  function refreshCart() {
    var drawer = document.querySelector('apt-cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh();

    var counter = document.querySelector('apt-cart-counter');
    if (counter && typeof counter.refresh === 'function') counter.refresh();
  }

  function setOpen(isOpen) {
    var drawer = document.querySelector('apt-cart-drawer');
    if (!drawer) return;
    drawer.classList.toggle(OPEN_CLASS, isOpen);
  }

  /** Ligne du panier portant le cadeau courant, 0 si aucun. */
  function currentGiftLine() {
    var picker = document.querySelector('apt-cart-gift-picker');
    return (picker && parseInt(picker.dataset.giftLine, 10)) || 0;
  }

  function removeGift(line) {
    if (!line || line <= 0) return Promise.resolve();

    return postJSON(cartRoute('cart_change_url', '/cart/change'), {
      line: line,
      quantity: 0,
    });
  }

  function selectGift(option) {
    var variantId = parseInt(option.dataset.giftVariantId, 10);
    if (busy || !variantId) return;

    // Cadeau déjà sélectionné : on referme, sans requête inutile.
    if (option.classList.contains('is-selected')) {
      setOpen(false);
      return;
    }

    busy = true;
    option.classList.add('is-loading');

    // On retire d'abord l'ancien cadeau : le panier ne doit jamais contenir deux
    // cadeaux, et retirer après l'ajout décalerait les index de ligne.
    removeGift(currentGiftLine())
      .then(function () {
        return postJSON(cartRoute('cart_add_url', '/cart/add'), {
          items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }],
        });
      })
      .then(function () {
        setOpen(false);
        refreshCart();
      })
      .catch(function (error) {
        console.error(error);
        option.classList.remove('is-loading');
      })
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    if (target.closest('[data-gift-open]')) {
      event.preventDefault();
      setOpen(true);
      return;
    }

    if (target.closest('[data-gift-close]')) {
      event.preventDefault();
      setOpen(false);
      return;
    }

    var option = target.closest('[data-gift-variant-id]');
    if (option) {
      event.preventDefault();
      selectGift(option);
      return;
    }

    // Fermer le panier referme aussi le drawer cadeau, sinon il serait encore
    // ouvert à la réouverture suivante.
    if (target.closest('[data-action="cart-drawer-close"]')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var drawer = document.querySelector('apt-cart-drawer');
    if (drawer && drawer.classList.contains(OPEN_CLASS)) {
      event.stopPropagation();
      setOpen(false);
    }
  });

  var AptCartGiftPicker = class extends HTMLElement {
    connectedCallback() {
      // Le panier est repassé sous le seuil : le cadeau n'est plus dû.
      if (this.dataset.autoRemove !== 'true') {
        autoRemoveAttempts = 0;
        return;
      }

      var line = parseInt(this.dataset.giftLine, 10) || 0;
      if (line <= 0 || autoRemoveAttempts >= MAX_AUTO_REMOVE_ATTEMPTS) return;

      autoRemoveAttempts += 1;
      setOpen(false);
      removeGift(line).then(refreshCart).catch(console.error);
    }
  };

  if (!customElements.get('apt-cart-gift-picker')) {
    customElements.define('apt-cart-gift-picker', AptCartGiftPicker);
  }
})();
